const GET_SAVE_ADMIN_TASK_VALUE = 'GET_SAVE_ADMIN_TASK_VALUE'
const SET_SAVE_ADMIN_TASK_VALUE = 'SET_SAVE_ADMIN_TASK_VALUE'

const GET_SAVE_ASSET_ADMIN_TASK_VALUE = 'GET_SAVE_ASSET_ADMIN_TASK_VALUE';
const SET_SAVE_ASSET_ADMIN_TASK_VALUE = 'SET_SAVE_ASSET_ADMIN_TASK_VALUE'

const GET_SAVE_AFE_ADMIN_TASK_VALUE = 'GET_SAVE_AFE_ADMIN_TASK_VALUE';
const SET_SAVE_AFE_ADMIN_TASK_VALUE = 'SET_SAVE_AFE_ADMIN_TASK_VALUE'

const SET_SAVED_STATUS = "SET_SAVED_STATUS"

export {
    GET_SAVE_ADMIN_TASK_VALUE,
    SET_SAVE_ADMIN_TASK_VALUE,
    SET_SAVED_STATUS,
    GET_SAVE_ASSET_ADMIN_TASK_VALUE,
    SET_SAVE_ASSET_ADMIN_TASK_VALUE,
    GET_SAVE_AFE_ADMIN_TASK_VALUE,
    SET_SAVE_AFE_ADMIN_TASK_VALUE
}
